var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_4fsIgAUHmN0uMkVKo8ExqlsFbTiHQbSK"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_4fsIgAUHmN0uMkVKo8ExqlsFbTiHQbSK)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 17.8 16.4 C 15.53 15.81 14.8 15.2 14.8 14.25 C 14.8 13.16 15.81 12.4 17.5 12.4 C 18.92 12.4 19.63 12.94 19.89 13.8 C 20.01 14.2 20.34 14.5 20.76 14.5 L 21.06 14.5 C 21.72 14.5 22.19 13.85 21.96 13.23 C 21.54 12.05 20.56 11.07 19 10.69 L 19 10 C 19 9.17 18.33 8.5 17.5 8.5 C 16.67 8.5 16 9.17 16 10 L 16 10.66 C 14.06 11.08 12.5 12.34 12.5 14.27 C 12.5 16.58 14.41 17.73 17.2 18.4 C 19.7 19 20.2 19.88 20.2 20.81 C 20.2 21.5 19.71 22.6 17.5 22.6 C 15.85 22.6 15 22.01 14.67 21.17 C 14.52 20.78 14.18 20.5 13.77 20.5 L 13.49 20.5 C 12.82 20.5 12.35 21.18 12.6 21.8 C 13.17 23.19 14.5 24.01 16 24.33 L 16 25 C 16 25.83 16.67 26.5 17.5 26.5 C 18.33 26.5 19 25.83 19 25 L 19 24.35 C 20.95 23.98 22.5 22.85 22.5 20.8 C 22.5 17.96 20.07 16.99 17.8 16.4 Z ",
    fill: "rgb(255,255,255)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/Dollar.044bf5a78ed53704e6395a2da467fa37.svg";
export { ForwardRef as ReactComponent };